import { AutoComplete, ISelectType, useFetch } from "@4uhub/lib4uhub";
import { Grid } from "@mui/material";
import { memo, useCallback, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { domainValueList } from "../../../../../../../services/domainValue.service";

const translationPath = "page.4uBus.integrationRule.integrationRuleMov.";

// Domínio Tasy "Tipo de Convênio" (identifier=11, conforme especificado no card).
const INSURANCE_TYPE_DOMAIN_IDENTIFIER = 11;

export const InsuranceTypeExternalIdThen = memo(() => {
  const { t } = useTranslation();

  const { sendRequest } = useFetch(domainValueList);

  const [options, setOptions] = useState<ISelectType[]>([]);

  const fetchOptions = useCallback(async () => {
    const { data, success } = await sendRequest({
      identifier: INSURANCE_TYPE_DOMAIN_IDENTIFIER,
    });
    if (data && success) {
      setOptions(
        data.map((item) => ({
          id: item.identifierValue,
          name: item.domainValueName,
        })),
      );
    }
  }, [sendRequest]);

  useEffect(() => {
    fetchOptions();
  }, [fetchOptions]);

  return (
    <Grid item xs={12} sm={6}>
      <AutoComplete
        options={options}
        name="insuranceTypeExternalIdThen"
        size="small"
        fullWidth
        getOptionLabel={({ name }) => name}
        label={t(translationPath + "insurance_type_external_id_then")}
      />
    </Grid>
  );
});
